export default "__VITE_ASSET__6aP2vroN__"